// extracted by mini-css-extract-plugin
export var close = "donateForm-module--close--AUZ6I";
export var donationWidget = "donateForm-module--donation-widget--tsP5j";
export var formContainer = "donateForm-module--formContainer--Z6AsB";
export var formWrapper = "donateForm-module--formWrapper--Q7BMD";
export var open = "donateForm-module--open--BnVdD";
export var section = "donateForm-module--section--w+Wb7";
export var show = "donateForm-module--show--X+HmC";